import { createFormHook } from "@tanstack/react-form";
import { fieldContext, formContext } from "./form-context";
import { Input } from "../components/Input";
import { PhoneInput } from "../components/PhoneInput";
import { CountrySelect } from "../components/CountrySelect";
import { Select } from "../components/Select";
import { Textarea } from "../components/Textarea";

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Input: Input,
    PhoneInput: PhoneInput,
    CountrySelect: CountrySelect,
    Select: Select,
    Textarea: Textarea,
  },
  formComponents: {},
});
